import { useEffect, useState } from 'react'

const remainingTime = (expiresAt) => (expiresAt ? Math.max(0, expiresAt - Date.now()) : 0)

export default function useTemporaryAccessCountdown(expiresAt) {
  const [remainingMs, setRemainingMs] = useState(() => remainingTime(expiresAt))

  useEffect(() => {
    const tick = () => setRemainingMs(remainingTime(expiresAt))
    tick()
    if (!expiresAt) return undefined
    const intervalId = window.setInterval(tick, 250)
    return () => window.clearInterval(intervalId)
  }, [expiresAt])

  return remainingMs
}
